export const FILTERS = [
  {label: '戒菸', key: 'smokingCessation'},
  {label: 'ICOPE評估醫事單位', key: 'icope'},
  {label: '代謝症候群防治機構', key: 'hpaPrevention'},
  {label: '成人健檢之醫療院所', key: 'adultHealthScreening'},
];

export const DEFAULT_FILTER = Object.fromEntries(
  FILTERS.map(filter => [filter.key, false])
)